export enum ProjectTempType {
  Project = 1,
  Template = 2
}

export enum ProjectTempStep {
  Step1 = 1,
  Step2 = 2,
  Step3 = 3,
  Step4 = 4,
}

export enum FormAuditType {
  NormalForm = 1,
  AuditForm = 2,   
}

export enum GroupType {
  Group = 1,
  SendFinalCopy = 2,
  ViewOnly = 3,   
}

export enum PlaceholderStatus {
  Empty=0,
  FormSelected=1,
  ProjectCreated=2,
  ProjectSent=3,
  ProjectCompleted=4
}

export enum FormOrShared {
  MyForm="MyForm",
  SharedWithMe="SharedWithMe",   
}

export enum ModuleName{
  Core= "Core",
  Contact= "Contact",
  Company ="Company"
 }

 export enum MessageTemplate {  
  BroadCast=1,
  RequestDocument=2,
  Fax=3,
  Project=4
}

export enum DocType{
  Core= 1,
  Contact= 2,
  Company=3
 }

 export enum RoleLevel {
  SuperAdmin=1,
  OrganizationAdmin=2,
  OfficeAdmin=3,
  User=11,
}